import { spaceCadet } from '@cogneed/react-utils';
import {
  Box, styled,
} from '@mui/material';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: '0px 0px',
  flexGrow: 1,

  '& .MuiBox-root.clientCard': {
    flexShrink: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 2,

    '& .MuiTypography-subtitle1': {
      color: spaceCadet[400],
      fontWeight: 700,
      fontSize: 10,
      lineHeight: theme.typography.h6.lineHeight,
      padding: '0px 4px',
      margin: 0,
      display: 'flex',
      gap: 4,
      '& svg': {
        fontSize: 14,
        display: 'block',
      },
    },

    '& .MuiButtonBase-root': {
      color: spaceCadet[500],
      fontWeight: 700,
      fontSize: 12,
      borderRadius: 4,
      padding: '6px 8px',
      backgroundColor: 'white',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      '& svg': {
        color: spaceCadet[400],
        fontSize: 16,
        display: 'block',
      },
    },
  },
}));
export default StyledBox;
